import React from 'react'
import { Button, Switch, FormControlLabel } from '@material-ui/core'
import { Row, Col } from 'react-bootstrap'
import { COLORES } from '../../../../../config/colores'

function ConfirmacionPesadoBruto (props) {
  const { cea, cpe, handleConfirmacion, pesoMaximo, pedirConfirmacion, mode = 'dark' } = props

  const confirmarDatos = () => {
    handleConfirmacion(true)
  }

  const rechazarDatos = () => {
    handleConfirmacion(false)
  }

  const disabled = cpe.pesoBruto > pesoMaximo

  return (
    <>
      { (cpe && cpe.errorDescripcion === 'Rechazo de chofer')
        ? <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            margin: 'auto'
          }}
        >
          <div className='loader' />
          <h4 style={{ color: COLORES.grey.dark, margin: '15px ' }} >
              Procesando datos
          </h4>
        </div>
        : <div className={`text-center container-confirmacion-chofer-${mode}`}>
          <div className={`cabecera-show-pesado-bruto-${mode}`}>
            <Row>
              <Col md={10}>
                { pedirConfirmacion
                  ? <h1 style={{ fontSize: '2.3rem' }}>
                        Confirme los <b>datos</b> y <b>peso de bruto</b>
                  </h1>
                  : <h1 style={{ fontSize: '2.3rem' }}>
                        Detalle de datos y <b>peso de bruto</b>
                  </h1>
                }
              </Col>

              <Col md={2}>
                <FormControlLabel
                  control={<Switch
                    color='default'
                    name='mode'
                    onChange={props.updateTheme}
                    checked={mode === 'dark'}
                  />
                  }
                  label='Modo oscuro'
                />
              </Col>

            </Row>

          </div>

          <hr />

          <Row className={`datos-confirmacion-chofer-${mode}`}>
            <Col md={6}>
              <h1 style={{ fontSize: '2.8rem' }}>Número CTG: <b>{cpe.numero}</b> </h1>
            </Col>
            <Col md={6}>
              {(cea && cea.camion) && <h1 style={{ fontSize: '2.8rem' }} >Camión: <b>{cea.camion}</b> </h1> }
            </Col>
          </Row>

          <div className={`container-pesos-bruto-chofer container-pesos-bruto-chofer-${mode}`}>
            <Col md={3} className={`box-dato-peso box-dato-peso-origen-${mode}`}>
              <h2 style={{ fontWeight: 'bold' }}>Peso bruto origen</h2>
              { cpe && <h1 className='peso-confirmacion-origen-br'>{cpe.pesoBrutoOrigen}</h1> }
            </Col>
            <Col md={7} className={`box-dato-peso box-peso-confirmacion-bruto-${mode}`}>
              <h2 className={`title-box-confirmacion-bruto title-box-confirmacion-bruto-${mode}`}>Peso bruto en Terminal Quequén</h2>
              { cpe && <h1 className='peso-confirmacion-bruto' style={{ margin: 0 }}>{cpe.pesoBruto}</h1> }
            </Col>
          </div>

          { (pedirConfirmacion === 1)
            ? <div className={`container-btn-confirmacion-chofer container-btn-confirmacion-chofer-${mode}`}>
              <Col md={5} className='btn-cancel-confirmacion-bruto'>
                <Button
                  variant='contained'
                  size='large'
                  className='button-panel-chofer'
                  style={{ margin: '1% auto', fontSize: '1.7rem', backgroundColor: COLORES.red.medium, color: COLORES.grey.light }}
                  onClick={() => { rechazarDatos() }}
                >
                      No estoy de acuerdo
                </Button>
                <h3 style={{ marginTop: '1.2%' }}>(No descargo por diferencia de peso)</h3>
              </Col>
              <Col md={6}>
                <Button
                  variant='contained'
                  size='large'
                  className={`button-panel-chofer button-panel-chofer-${mode} button-confirmar-chofer-${mode}`}
                  style={{ backgroundColor: COLORES.green.light, color: COLORES.grey.dark }}
                  onClick={() => { confirmarDatos() }}
                  disabled={disabled}
                >
                      Confirmar peso
                </Button>
              </Col>
            </div>
            : <></>
          }
        </div>

      }
    </>

  )
}

export default ConfirmacionPesadoBruto
